// extracted by mini-css-extract-plugin
export default {"container":"NoData_container__izI0u","hide":"NoData_hide__M0tX9","loader":"NoData_loader__vD8LD","rotating":"NoData_rotating__0udtL"};